// extracted by mini-css-extract-plugin
export default {"root":"HistoryDialog_root__odn-8","content":"HistoryDialog_content__BZOGa","section":"HistoryDialog_section__wC98U"};